import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const BonvoyAtAGlance = dynamic(() => import('./BonvoyAtAGlance').then(mod => mod.BonvoyAtAGlance));

export const BonvoyAtAGlanceConfig = {
  emptyLabel: 'Bonvoy At A Glance',
  isEmpty: false,
  resourceType: 'mi-aem-account/components/content/bonvoyataglance',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BonvoyAtAGlanceEditable = (props: any) => {
  const isHidden = props?.model?.hideComponent;

  return (
    <EditableComponent config={BonvoyAtAGlanceConfig} {...props}>
      {(!isHidden || props?.isAuthorMode) && <BonvoyAtAGlance {...props} />}
    </EditableComponent>
  );
};
